import { FiMenu, FiPlus, FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const Topbar = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="topbar">
      <button className="icon-button topbar__menu" onClick={onMenuClick} aria-label="Abrir menu">
        <FiMenu />
      </button>
      <div className="topbar__title">
        <span className="eyebrow">{user?.role === "ADMIN" ? "Painel do admin" : "Painel do anunciante"}</span>
        <h1>Shopalli</h1>
      </div>
      <div className="topbar__actions">
        <div className="topbar__user hidden md:flex">
          <div className="avatar">{user?.email?.[0]?.toUpperCase() || "A"}</div>
          <div>
            <strong>{user?.email || "Anunciante"}</strong>
          </div>
        </div>
        <button className="icon-button !bg-red-600 !text-white" onClick={handleLogout} title="Sair">
          <FiLogOut />
        </button>
      </div>
    </header>
  );
};

export default Topbar;
